import {Box, HStack} from 'platform/foundation';
import {Pattern, match} from 'ts-pattern';

import {ReactNode} from 'react';

import {TestIdProps} from 'shared/web';

export interface PersonnelOverviewWrapperProps extends TestIdProps {
  externalFilterId?: string;
  children: ReactNode;
}

export function PersonnelOverviewWrapper(props: PersonnelOverviewWrapperProps) {
  return match(props.externalFilterId)
    .with(Pattern.nullish, () => (
      <Box flex={1} height="100%" minWidth={0} data-testid={props['data-testid']}>
        {props.children}
      </Box>
    ))
    .otherwise((externalFilterId) => (
      <HStack spacing={3} height="100%" data-testid={props['data-testid']}>
        <div id={externalFilterId} />
        <Box flex={1} height="100%" minWidth={0}>
          {props.children}
        </Box>
      </HStack>
    ));
}
